import { render, staticRenderFns } from "./dataLog.vue?vue&type=template&id=23584c2b&scoped=true"
import script from "./dataLog.vue?vue&type=script&lang=js"
export * from "./dataLog.vue?vue&type=script&lang=js"
import style0 from "./dataLog.vue?vue&type=style&index=0&id=23584c2b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23584c2b",
  null
  
)

export default component.exports